._ErrorBoundary_khnz5_1 {
  margin: 30px auto;
  white-space: pre-wrap;
}